import { useEffect, useRef, useState, useCallback } from 'react';

const BRT_OFFSET_HOURS = -3; // Horario de Brasilia (sem horario de verao)

function isBusinessHours() {
  const now = new Date();
  const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
  const brt = new Date(utcMs + BRT_OFFSET_HOURS * 3600000);
  const day = brt.getDay(); // 0=domingo .. 6=sabado
  const hour = brt.getHours();
  return day >= 1 && day <= 5 && hour >= 8 && hour < 18;
}

/**
 * Roda fetchFn uma vez ao montar. Depois disso so repete sozinho a cada
 * intervalMs enquanto estiver dentro do horario comercial (seg-sex 08h-18h,
 * horario de Brasilia) -- fora desse horario o dado so atualiza quando o
 * usuario clicar em "Atualizar" (o `refresh` retornado por este hook).
 *
 * Troca onSnapshot (poll continuo a cada ~2min, tabela inteira) por
 * getDocs sob demanda -- criado para cortar consumo de dados do Supabase.
 */
export function useBusinessHoursPolling(fetchFn, intervalMs = 3600000) {
  const [lastUpdated, setLastUpdated] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const fetchRef = useRef(fetchFn);
  fetchRef.current = fetchFn;

  const run = useCallback(async () => {
    setRefreshing(true);
    try {
      await fetchRef.current();
      setLastUpdated(new Date());
    } finally {
      setRefreshing(false);
    }
  }, []);

  useEffect(() => {
    run();
    const id = setInterval(() => { if (isBusinessHours()) run(); }, intervalMs);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalMs]);

  return { lastUpdated, refreshing, refresh: run };
}

export function formatLastUpdated(date) {
  if (!date) return '';
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}
